import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { VideoModalComponent } from '../video-modal/video-modal.component';

@Component({
  selector: 'app-behavior-info-card',
  standalone: true,
  imports: [
    CommonModule,
    NzButtonModule,
    SvgIconComponent,
    VideoModalComponent,
  ],
  styleUrls: ['./behavior-info-card.component.scss'],
  template: `
    <div *ngIf="mode !== 'view'" class="mb-24">
      <div class="header-with-cta mb-24">
        <h3 class="title s-18">
          {{ behaviorCategoryName }}
        </h3>
      </div>
      <h4 class="title s-16 mb-16">Behavior</h4>
      <div class="behavior-badge-wrapper badge-container">
        <div class="behavior-list">
          <span class="badge" *ngFor="let type of behaviorTypes">
            {{ type.behaviorTypeName }}
          </span>
        </div>
        <button
          *ngIf="videoUrl"
          nz-button
          type="button"
          nzType="text"
          class="video-button"
          (click)="openVideoUrl(videoUrl)">
          <svg-icon
            [title]="'Play Video'"
            src="/assets/icon/icon-play.svg"
            class="icon s-20"></svg-icon>
        </button>
      </div>
    </div>

    <app-video-modal [(visible)]="isVideoVisible" [videoUrl]="videoUrl ?? ''">
    </app-video-modal>
  `,
})
export class BehaviorInfoCardComponent {
  @Input() mode?: string;
  @Input() behaviorCategoryName?: string;
  @Input() behaviorTypes?: { behaviorTypeName: string }[];
  @Input() videoUrl?: string | null = null;
  isVideoVisible = false;

  openVideoUrl(url: string): void {
    this.isVideoVisible = true;
    this.videoUrl = url;
  }
}
